import React, {
  useState,
  useEffect
} from 'react';

import {SiteLinks} from '../../general';

function ThesisUGBPageInfo() {
  return (<SiteLinks screen="s2_student_ugb" />);
}

export {ThesisUGBPageInfo};